import { Asset } from '~modules/media-library/model/Asset';
import { InfoBubble, LawBubble, MasterVersionBubble } from '~modules/media-library/view/MetaBubble/Bubble';

export function Bubbles({ asset, className = '' }: { asset: Asset; className?: string }) {
  return (
    <div className={`ml--metabubbles flex gap-1 ${className}`}>
      <MasterVersionBubble asset={asset} />
      <InfoBubble title={asset.attributes.usageNotice} />
      <LawBubble title={asset.attributes.legalNotice} />
    </div>
  );
}
